import React from 'react';
import Ws from '../providers/Ws';
import { Grid, List, Checkbox, FormControl, InputLabel, Select, FilledInput, MenuItem, Button } from '@material-ui/core';
import Utils from '../providers/Utils';
import { isAfter } from 'date-fns';
import departament from '../Pics/departament.jpeg'
import avatar from '../Pics/avatar.jpg'
import AlertDialog from './dialogs/AlertDialog';
import SpecificComponent from './SpecificComponent';
import UpdateAngajatDetails from './dialogs/UpdateAngajatDetails';
import ProgramLucru from './dialogs/ProgramLucru';
import PropTypes from 'prop-types'
import FromServer from '../module/useri/FromServer';
import { Promise } from 'q';
import NewUserDrepturi from './dialogs/NewUserDrepturi';
import LocalStorage from '../providers/LocalStorage';
import AlertNew from './dialogs/AlertNew';
import ProgramCompanie from '../module/administrare/ProgramCompanie';


export default class Organigrama extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listOrganigrama: [],
            rows: 0,
            cells: 0,
            elId: '',
            angajatNou: 'Adauga Angajat',
            culoriDepartamente: new Utils().culoriDepartamente,
            isOpenDelete: false,
            objDeptSelectat: {},
            idContainerAngajat: '',
            objInfoAngajat: {
                sef_departament: 0,
                lu_start: '',
                lu_end: '',
                ma_start: '',
                ma_end: '',
                mi_start: '',
                mi_end: '',
                jo_start: '',
                jo_end: '',
                vi_start: '',
                vi_end: '',
                sa_start: '',
                sa_end: '',
                du_start: '',
                du_end: ''
            },
            isOpenDetaliiAngajat: false,
            isOpenProgram: false,
            tipuriMoneda: [
                { id: 'euro', nume: '€' },
                { id: 'lei', nume: 'Lei' },
                { id: 'dollar', nume: '$' }
            ],
            isOpenNewUser: false,
            toUpdate: false,
            angajatInfo: {
                adresa: "",
                cnp: "",
                cost_minut: '',
                email: "",
                firma: '',
                functie: "",
                id: 0,
                id_departament: 0,
                id_user: 0,
                nume: "",
                nume_departament: "",
                oras: "",
                poza: "",
                salariu: '',
                sef_departament: '',
                telefon: "",
            },
            listDepartamente: [],
            isFirmaExterna: false,
            verifyEmail: '',
            parola: '',
            repetParola: '',
            vParola: '',
            isOpenProgram: false,
            societate: {},
            dAccess: [],
            idDepartament: 0,
            openDeleteUser: false,
            openProgramCompanie: false,
            programSelectat: -1,
            programCompanie: [],
            listUseriAll: [],
            openAlertUseri: false


        }
    }


    localConfig = {
        isDragging: false,
        height: 50,
        pos1: 0,
        pos2: 0,
        pos3: 0,
        pos4: 0,
        el: '',
        elParent: '',
        padding: 20,

    }



    componentDidMount() {
        this.getOrganigrama()

        this.getProgramCompanie()

        window.addEventListener('resize', this.getWindowDimentions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getWindowDimentions())
    }

    componentWillMount() {
        this.getWindowDimentions()
    }

    ws = new Ws()
    u = new Utils()

    getProgramCompanie = async () => {

        let getProgram = await this.ws.customSelect('select * from program_lucru where isnull(este_template,0)=1 and isnull(sters,0)!=1', {
            p1: 1
        })

        if (getProgram.Succes) {

            let programCompanie = [...getProgram.Content]

            for (let i = 0, n = programCompanie.length; i < n; i++) {

                programCompanie[i].lu_start = this.u.transformTimeFromSql(programCompanie[i].lu_start)
                programCompanie[i].lu_end = this.u.transformTimeFromSql(programCompanie[i].lu_end)
                programCompanie[i].ma_start = this.u.transformTimeFromSql(programCompanie[i].ma_start)
                programCompanie[i].ma_end = this.u.transformTimeFromSql(programCompanie[i].ma_end)
                programCompanie[i].mi_start = this.u.transformTimeFromSql(programCompanie[i].mi_start)
                programCompanie[i].mi_end = this.u.transformTimeFromSql(programCompanie[i].mi_end)
                programCompanie[i].jo_start = this.u.transformTimeFromSql(programCompanie[i].jo_start)
                programCompanie[i].jo_end = this.u.transformTimeFromSql(programCompanie[i].jo_end)
                programCompanie[i].vi_start = this.u.transformTimeFromSql(programCompanie[i].vi_start)
                programCompanie[i].vi_end = this.u.transformTimeFromSql(programCompanie[i].vi_end)
                programCompanie[i].sa_start = this.u.transformTimeFromSql(programCompanie[i].sa_start)
                programCompanie[i].sa_end = this.u.transformTimeFromSql(programCompanie[i].sa_end)
                programCompanie[i].du_start = this.u.transformTimeFromSql(programCompanie[i].du_start)
                programCompanie[i].du_end = this.u.transformTimeFromSql(programCompanie[i].du_end)


                programCompanie[i].lu_pauza_start = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_start)
                programCompanie[i].lu_pauza_end = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_end)
                programCompanie[i].ma_pauza_start = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_start)
                programCompanie[i].ma_pauza_end = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_end)
                programCompanie[i].mi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_start)
                programCompanie[i].mi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_end)
                programCompanie[i].jo_pauza_start = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_start)
                programCompanie[i].jo_pauza_end = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_end)
                programCompanie[i].vi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_start)
                programCompanie[i].vi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_end)
                programCompanie[i].sa_pauza_start = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_start)
                programCompanie[i].sa_pauza_end = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_end)
                programCompanie[i].du_pauza_start = this.u.transformTimeFromSql(programCompanie[i].du_pauza_start)
                programCompanie[i].du_pauza_end = this.u.transformTimeFromSql(programCompanie[i].du_pauza_end)
            }


            console.log('programCompanie :>> ', programCompanie);
            this.setState({
                programCompanie: programCompanie,
                programSelectat: programCompanie.length > 0 ? programCompanie[0] : null

            })
        }
    }


    changeProgramAll = (ev) => {

        let val = ev.target.value

        let programe = [...this.state.programCompanie]

        let idx = programe.findIndex(i => Number(i.id) === Number(val))

        console.log('idx :>> ', idx);
        if (idx !== -1) {

            console.log('programe :>> ', programe[idx]);

            let angajatInfo = { ...this.state.angajatInfo }

            angajatInfo.lu_start = programe[idx].lu_start
            angajatInfo.lu_end = programe[idx].lu_end
            angajatInfo.ma_start = programe[idx].ma_start
            angajatInfo.ma_end = programe[idx].ma_end
            angajatInfo.mi_start = programe[idx].mi_start
            angajatInfo.mi_end = programe[idx].mi_end
            angajatInfo.jo_start = programe[idx].jo_start
            angajatInfo.jo_end = programe[idx].jo_end
            angajatInfo.vi_start = programe[idx].vi_start
            angajatInfo.vi_end = programe[idx].vi_end
            angajatInfo.sa_start = programe[idx].sa_start
            angajatInfo.sa_end = programe[idx].sa_end
            angajatInfo.du_start = programe[idx].du_start
            angajatInfo.du_end = programe[idx].du_end



            this.setState({
                angajatInfo: angajatInfo,
                programSelectat: val
            }, () => {
                this.saveProgram()
            })
        }

    }


    getOrganigrama = async (angajat = null) => {

        let ws = new Ws()

        let existaDepartamente = await ws.customSelect('select count(*) as dep from departamente where isnull(inactiv,0) != @p1', {
            p1: 1
        })

        if (existaDepartamente.Succes) {

            if (existaDepartamente.Content[0].dep > 0) {

                let getSocietate = await ws.customSelect('select * from setari', {
                    p1: 'soc_code'
                })

                if (getSocietate.Succes) {
                    let _departamente = ws.customSelect(`select d.id, d.poza, d.nume, d.[level], d.id_parent, o.[margintop], o.[marginleft], o.[width],
                        o.[height], o.color from departamente d left outer join organigrama_display_data o
                         on (d.id = o.id_departament) where isnull(d.inactiv,0) != @p1 `, {
                        p1: 1
                    })



                    let _angajati = ws.customSelect(`select
                                        a.id , dep.id as id_departament, u.id as id_user,
                                        a.permis_conducere,
                                        l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
                                        ad.sef_departament,a.cnp,a.adresa,a.telefon,u.token,
                                        a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.salariu_moneda, a.nr_zile_concediu,  u.access_financiar, a.doc_fisa_postului,a.cv, u.email, u.firma, u.firma_externa, u.is_admin, dep.nume as nume_departament  from  useri u
                                        left join angajati a on u.id = a.id_user 
                                        left join angajati_departamente ad on ad.id_angajat = a.id
                                        left join departamente dep on dep.id = ad.id_departament
                                        left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
                                        where isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 and isnull(u.firma_externa, 0) != 1 order by a.nume asc`, {
                        p1: 1,
                        p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
                    })

                    // let _angajati = ws.customSelect(`select a.*, ad.sef_departament, ad.id_departament from angajati a left join angajati_departamente ad on a.id = ad.id_angajat where isnull(a.inactiv,0) != @p1 and isnull(ad.inactiv,0) !=@p1`,{
                    //     p1:1
                    // })

                    let programLucru = ws.customSelect('select * from program_lucru where 1 = @p1', {
                        p1: 1
                    })


                    let _departementeAcces = ws.customSelect(`select d.*, a.id as id_departament_access, a.id_angajat from angajati_acces_departamente a left join departamente d  on
                                        d.id = a.id_departament where a.id_angajat = @p1 and isnull(a.sters,0) != 1`, { p1: this.state.angajatInfo.id })



                    let [d, a, p, dAccess] = await Promise.all([_departamente, _angajati, programLucru, _departementeAcces])

                    // console.log('_departamente :', d);
                    console.log(' angajati:', a);

                    if (d.Succes && a.Succes && p.Succes) {


                        let time = new Utils()

                        let cloneA = [...a.Content]

                        // console.log('cloneA :', cloneA);


                        let maxLevel = Math.max.apply(Math, d.Content.map((o) => { return o.level }))

                        // console.log('maxLeve :', maxLevel);

                        let angajatSelectat = [{
                            sef_departament: 0,
                            lu_start: '',
                            lu_end: '',
                            ma_start: '',
                            ma_end: '',
                            mi_start: '',
                            mi_end: '',
                            jo_start: '',
                            jo_end: '',
                            vi_start: '',
                            vi_end: '',
                            sa_start: '',
                            sa_end: '',
                            du_start: '',
                            du_end: ''
                        }]






                        let rez = []
                        let topContainer = 0
                        // for(let i =1; i<= maxLevel; i++){
                        // let depts  = d.Content.filter( d => d.level === i)
                        // console.log('depts :', depts);



                        let depts = d.Content

                        let counter = depts.length
                        for (let j = 0; j < counter; j++) {
                            let angajati = a.Content.filter(a => a.id_departament === depts[j].id)
                            let program = p.Content



                            let sef = angajati.filter(s => s.sef_departament === 1)

                            let counterA = angajati.length

                            for (let k = 0; k < counterA; k++) {
                                let idx = program.findIndex(p => p.id_angajat === angajati[k].id)

                                angajati[k].selectat = false
                                angajati[k].lu_start = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_start) : '00:00'
                                angajati[k].lu_end = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_end) : '18:00'
                                angajati[k].ma_start = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_start) : '00:00'
                                angajati[k].ma_end = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_end) : '18:00'
                                angajati[k].mi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_start) : '00:00'
                                angajati[k].mi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_end) : '18:00'
                                angajati[k].jo_start = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_start) : '00:00'
                                angajati[k].jo_end = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_end) : '18:00'
                                angajati[k].vi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_start) : '00:00'
                                angajati[k].vi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_end) : '18:00'
                                angajati[k].sa_start = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_start) : '00:00'
                                angajati[k].sa_end = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_end) : '18:00'
                                angajati[k].du_start = idx !== -1 ? time.transformTimeFromSql(program[idx].du_start) : '00:00'
                                angajati[k].du_end = idx !== -1 ? time.transformTimeFromSql(program[idx].du_end) : '18:00'



                            }



                            if (angajat) {
                                angajatSelectat = cloneA.filter(a => a.id === angajat.id)

                                // console.log('angajatSelectat :', angajatSelectat);
                                let idx1 = p.Content.findIndex(p => p.id_angajat === angajatSelectat[0].id)
                                if (angajatSelectat.length > 0) {

                                    angajatSelectat[0].selectat = false
                                    angajatSelectat[0].lu_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].lu_start) : '00:00'
                                    angajatSelectat[0].lu_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].lu_end) : '18:00'
                                    angajatSelectat[0].ma_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].ma_start) : '00:00'
                                    angajatSelectat[0].ma_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].ma_end) : '18:00'
                                    angajatSelectat[0].mi_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].mi_start) : '00:00'
                                    angajatSelectat[0].mi_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].mi_end) : '18:00'
                                    angajatSelectat[0].jo_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].jo_start) : '00:00'
                                    angajatSelectat[0].jo_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].jo_end) : '18:00'
                                    angajatSelectat[0].vi_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].vi_start) : '00:00'
                                    angajatSelectat[0].vi_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].vi_end) : '18:00'
                                    angajatSelectat[0].sa_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].sa_start) : '00:00'
                                    angajatSelectat[0].sa_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].sa_end) : '18:00'
                                    angajatSelectat[0].du_start = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].du_start) : '00:00'
                                    angajatSelectat[0].du_end = idx1 !== -1 ? time.transformTimeFromSql(p.Content[idx1].du_end) : '18:00'
                                }


                                let angajat = { ...this.state.angajatInfo }

                                let idx = angajati.findIndex(i => i.id === a.id)

                                if (idx !== -1) {
                                    let newAngajat = angajati[idx]

                                    this.setState({ angajatInfo: newAngajat })
                                }

                            }


                            let parent = depts.findIndex(d => d.id === depts[j].id_parent)

                            // console.log('parent :', parent);

                            depts[j].ipo = null
                            if (parent !== -1) {

                                let cat1 = depts[j].marginleft - depts[parent].marginleft
                                let cat2 = depts[j].margintop - depts[parent].margintop - ((this.localConfig.height + this.localConfig.padding) / 2)
                                let ipo = Math.sqrt(Math.pow(cat1, 2) + Math.pow(cat2, 2))




                                depts[j].ipo = ipo
                                depts[j].degree = this.rad2degree(Math.asin(cat1 / ipo))
                                depts[j].cat1 = cat1
                                depts[j].cat2 = cat2
                            }

                            depts[j].selectat = false
                            depts[j].angajati = angajati
                            depts[j].width = 'fit-content'
                            depts[j].height = '100%'
                            depts[j].minHeight = this.localConfig.height
                            depts[j].padding = this.localConfig.padding


                        }

                        // topContainer = (this.localConfig.margin * this.localConfig.height) * i
                        // rez.push ({level:i, depts:depts, top: topContainer})
                        // }




                        this.setState({
                            listOrganigrama: depts,
                            listDepartamente: d.Content,
                            societate: getSocietate.Content[0],
                            objDeptSelectat: d.Content[0],
                            parola: '',
                            repetParola: '',
                            dAccess: dAccess.Content,
                            objInfoAngajat: angajatSelectat[0],
                            listUseriAll: a.Content
                        }, () => {
                            // console.log('this.state.organi :', this.state.listOrganigrama);
                        })

                        // console.log('rez :', rez);
                    }

                }



            } else {
                let objInsertDep = {
                    nume: 'GM',


                }


                // console.log('objInsertDep :', objInsertDep);


                let insertDep = await ws.insert('departamente', objInsertDep)

                // console.log('insert Dep  :', insertDep);

                if (insertDep.Succes) {
                    let objToInsertDisplay = {
                        margintop: 50,
                        marginleft: 100,
                        id_departament: insertDep.Content[0].id
                    }

                    let insertDisplay = await ws.insert('organigrama_display_data', objToInsertDisplay)

                    if (insertDisplay.Succes) {
                        this.getOrganigrama()
                    }
                }
            }
        }

    }


    rad2degree = (rad) => {

        let PI = Math.PI

        return rad * (180 / PI)
    }

    showGridLines = () => {



        let container = []


        let tRows = []

        for (let i = 0; i < this.state.rows; i++) {
            let tCells = []
            for (let j = 0; j < this.state.cells; j++) {
                tCells.push(<td data-idtr={`tr${i}`} id={`td${j}`} style={{
                    width: 10,
                    borderLeft: j === 0 ? '1px solid #968c8c' : 'none',
                    borderTop: i === 0 ? '1px solid #968c8c' : 'none',

                    borderRight: '1px solid #968c8c'
                }} key={j}></td>)


            }


            tRows.push(<tr id={`tr${i}`} style={{
                borderTop: i === 0 ? '1px solid #968c8c' : 'none',
                height: 10,
                borderBottom: '1px solid #968c8c'
            }} key={i}>{tCells}


            </tr>)
        }

        container = <table style={{ borderCollapse: 'collapse' }}>
            <tbody>
                {tRows}
            </tbody>
        </table>

        return container
    }


    getWindowDimentions = () => {
        let windowHeight = window.innerHeight
        let windowWidth = window.innerWidth

        // console.log('windowHeight :', windowHeight);
        // console.log('windowWidth :', windowWidth);

        this.setState({
            rows: Math.trunc(windowHeight / this.localConfig.height),
            cells: Math.trunc(windowWidth / this.localConfig.width)
        }, () => {
            // console.log('this.state.rows :', this.state.rows);
            // console.log('this.state.cells :', this.state.cells);
        })


        // let
    }

    newElDrag = (e) => {
        this.localConfig.pos1 = 0
        this.localConfig.pos2 = 0
        this.localConfig.pos3 = 0
        this.localConfig.pos4 = 0

        // console.log('e :', e);
        e = e || window.event;
        e.preventDefault();
        this.localConfig.pos3 = e.clientX;
        this.localConfig.pos4 = e.clientY;
        document.onmouseup = this.closeNewDrag
        document.onmousemove = this.newElementDrag;
        this.localConfig.el = document.getElementById(e.target.id).cloneNode(true)


        this.localConfig.el.style.top = (document.getElementById(e.target.id).offsetTop + 150) + "px";
        this.localConfig.el.style.left = document.getElementById(e.target.id).offsetLeft + 'px'
        this.localConfig.el.style.right = 'unset'
        this.localConfig.el.innerHTML = 'Departament Nou'
    }

    mouseOverDep = (e, d) => {
        // console.log('eover :', e.target);
        // console.log('d :', d);



        this.localConfig.elParent = d

    }

    newElementDrag = (e) => {
        e = e || window.event;


        e.preventDefault();
        this.localConfig.pos1 = this.localConfig.pos3 - e.clientX;
        this.localConfig.pos2 = this.localConfig.pos4 - e.clientY;
        this.localConfig.pos3 = e.clientX;
        this.localConfig.pos4 = e.clientY;
        let vertical = document.getElementById('vertical-line')
        let horizontal = document.getElementById('horizontal-line')

        vertical.style.display = 'block'
        vertical.style.left = (this.localConfig.el.offsetLeft - this.localConfig.pos1) + "px";
        horizontal.style.display = 'block'
        horizontal.style.top = (this.localConfig.el.offsetTop - this.localConfig.pos2) + "px";

        document.getElementById('pm-organigrama-container').appendChild(this.localConfig.el)


        this.localConfig.el.style.top = (this.localConfig.el.offsetTop - this.localConfig.pos2) + "px";
        this.localConfig.el.style.left = (this.localConfig.el.offsetLeft - this.localConfig.pos1) + "px";


    }

    closeNewDrag = async () => {

        let vertical = document.getElementById('vertical-line')
        let horizontal = document.getElementById('horizontal-line')


        vertical.style.display = 'none'
        horizontal.style.display = 'none'

        // console.log('this.local :', this.localConfig.elParent);

        if (this.localConfig.elParent) {
            // console.log('this.localConfig.elParent :', this.localConfig.elParent);

            let objInsertDep = {
                nume: 'Departament Nou',
                id_parent: this.localConfig.elParent.id


            }



            let ws = new Ws();

            // console.log('objInsertDep :', objInsertDep);


            let insertDep = await ws.insert('departamente', objInsertDep)

            // console.log('insert Dep  :', insertDep);

            if (insertDep.Succes) {
                let objToInsertDisplay = {
                    margintop: this.getNumbersFromStyle(this.localConfig.el.style.top),
                    marginleft: this.getNumbersFromStyle(this.localConfig.el.style.left),
                    id_departament: insertDep.Content[0].id
                }

                let insertDisplay = await ws.insert('organigrama_display_data', objToInsertDisplay)

                if (insertDisplay.Succes) {
                    this.localConfig.el.style.display = 'none'
                    this.getOrganigrama()
                }
            }

        }

        this.localConfig.el.style.display = 'none'
        this.localConfig.elParent = null

        document.onmouseup = null;
        document.onmousemove = null;
        document.onmouseover = null;

        this.localConfig = {
            isDragging: false,
            height: 50,
            pos1: 0,
            pos2: 0,
            pos3: 0,
            pos4: 0,
            el: '',
            elParent: '',
            padding: 20
        }
    }



    dragEl = (e, i, id, linie) => {
        this.localConfig.pos1 = 0
        this.localConfig.pos2 = 0
        this.localConfig.pos3 = 0
        this.localConfig.pos4 = 0
        this.localConfig.isDragging = false
        this.localConfig.departament = i
        this.localConfig.linie = linie

        console.log('dragEl :', e.target.id);

        console.log('id :', id);
        console.log('i :>> ', i);



        if (this.props.scop === 'Organigrama') {

            if (e.target.id === id) {

                let lV = document.getElementById(linie)

                lV.style.display = 'none'

                // console.log('enterDragDown :' );
                e = e || window.event;
                e.preventDefault();
                this.localConfig.pos3 = e.clientX;
                this.localConfig.pos4 = e.clientY;

                console.log('this.localConfig.pos3  :>> ', this.localConfig.pos3);
                console.log('this.localConfig.pos4 :>> ', this.localConfig.pos4);
                document.onmouseup = this.closeDragElement
                document.onmousemove = this.elementDrag;
            }
        }

        this.localConfig.el = document.getElementById(e.target.id)

        if (this.localConfig.el) {

            this.localConfig.el.style.zIndex = (this.localConfig.el.style.zIndex == 1000 ? 1001 : 1000)
        }

        if (this.localConfig.focusedInput) {

            this.localConfig.focusedInput.blur()
        }



    }

    dragElButton = (e, d, id, linie) => {
        this.localConfig.pos1 = 0
        this.localConfig.pos2 = 0
        this.localConfig.pos3 = 0
        this.localConfig.pos4 = 0
        this.localConfig.isDragging = false
        this.localConfig.departament = d
        this.localConfig.linie = linie

        if (this.props.scop === 'Organigrama') {



            let lV = document.getElementById(linie)


            lV.style.display = 'none'

            // console.log('enterDragDown :' );
            e = e || window.event;
            e.preventDefault();
            this.localConfig.pos3 = e.clientX;
            this.localConfig.pos4 = e.clientY;

            console.log('this.localConfig.pos3  :>> ', this.localConfig.pos3);
            console.log('this.localConfig.pos4 :>> ', this.localConfig.pos4);

            this.localConfig.el = document.getElementById(id)

            console.log('this.localConfig.el MY ID:>> ', this.localConfig.el);

            if (this.localConfig.el) {

                console.log('this.localConfig.el MY ID 2:>> ', this.localConfig.el);

                this.localConfig.el.style.zIndex = (this.localConfig.el.style.zIndex == 1000 ? 1001 : 1000)
            }

            if (this.localConfig.focusedInput) {

                this.localConfig.focusedInput.blur()
            }
            document.onmouseup = this.closeDragElement
            document.onmousemove = this.elementDrag;

        }

        console.log('id :>> ', id);



    }



    elementDrag = (e) => {

        console.log('this.localConfig.el) :>> ', this.localConfig.el);

        if (this.localConfig.el) {

            this.localConfig.isDragging = true

            e = e || window.event;

            e.preventDefault();
            this.localConfig.pos1 = this.localConfig.pos3 - e.clientX;
            this.localConfig.pos2 = this.localConfig.pos4 - e.clientY;
            this.localConfig.pos3 = e.clientX;
            this.localConfig.pos4 = e.clientY;
            let vertical = document.getElementById('vertical-line')
            let horizontal = document.getElementById('horizontal-line')

            vertical.style.display = 'block'
            vertical.style.left = (this.localConfig.el.offsetLeft - this.localConfig.pos1) + "px";
            horizontal.style.display = 'block'
            horizontal.style.top = (this.localConfig.el.offsetTop - this.localConfig.pos2) + "px";

            // el.style.transform = "translate3d(" +(el.offsetTop - pos2) + "px, " +(el.offsetLeft - pos1) + "px, 0)";
            this.localConfig.el.style.top = (this.localConfig.el.offsetTop - this.localConfig.pos2) + "px";
            this.localConfig.el.style.left = (this.localConfig.el.offsetLeft - this.localConfig.pos1) + "px";


        }


    }

    closeDragElement = async () => {

        let vertical = document.getElementById('vertical-line')
        let horizontal = document.getElementById('horizontal-line')


        vertical.style.display = 'none'
        horizontal.style.display = 'none'



        if (this.localConfig.isDragging) {

            let lV = document.getElementById(this.localConfig.linie)

            lV.style.display = 'block'

            // console.log('el.style.top :', this.localConfig.el.style.top);
            // console.log('el.style.left :', this.localConfig.el.style.left);
            // console.log('this.localConfig.departament :', this.localConfig.departament);



            let objToUpdate = {
                margintop: this.getNumbersFromStyle(this.localConfig.el.style.top),
                marginleft: this.getNumbersFromStyle(this.localConfig.el.style.left)
            }

            console.log('objToUpdate :>> ', objToUpdate);
            console.log('this.localConfig.departament.id :>> ', this.localConfig.departament.id);

            let ws = new Ws();

            let updateDepartamente = await ws.update('organigrama_display_data', objToUpdate,
                { id_departament: this.localConfig.departament.id })

            console.log('updateDepartamente :', updateDepartamente);

            if (updateDepartamente.Succes) {

                // console.log('updateOk :');
                this.getOrganigrama()
            }
        }

        document.onmouseup = null;
        document.onmousemove = null;
        this.localConfig = {
            isDragging: false,
            height: 50,
            pos1: 0,
            pos2: 0,
            pos3: 0,
            pos4: 0,
            el: '',
            elParent: '',
            padding: 20
        }
    }

    getNumbersFromStyle = (s) => Number(s.replace('px', ''))

    changeNume = (ev, d) => {
        if (this.props.scop === 'Organigrama') {
            // console.log('ev :', ev);
            // console.log('d :', d);

            let listDepartamente = [...this.state.listOrganigrama]

            let idx = listDepartamente.findIndex(di => di.id === d.id)

            listDepartamente[idx].nume = ev.target.value

            this.setState({ listOrganigrama: listDepartamente })
        }

    }

    updateNumeDep = async (d) => {
        if (this.props.scop === 'Organigrama') {
            let ws = new Ws()

            let listDepartamente = [...this.state.listOrganigrama]

            let idx = listDepartamente.findIndex(di => di.id === d.id)




            let updateNume = await ws.update('departamente',
                { nume: listDepartamente[idx].nume },
                { id: d.id })

            if (updateNume.Succes) {
                //    console.log('nume updated success :');
            }
        }
    }



    inputClicked = (ev) => {
        //  console.log('ev.target.focus :', ev.target.focus);

        //  console.log('ev.target.id :', ev.target.id);

        this.localConfig.focusedInput = document.getElementById(ev.target.id)

        document.getElementById(ev.target.id).focus()

    }

    getAngajati = (d, idx) => {


        // console.log('departament :', d);

        let el = document.getElementById(`ang${idx}`)

        let depLine = document.getElementById(`etapaline${idx}`)

        let dep = document.getElementById(`dep${idx}`)

        if (el.style.display === 'block') {
            if (depLine) {

                depLine.style.display = 'block'
            }
            dep.style.zIndex = 1000
            el.style.display = 'none'
        } else {

            if (depLine) {

                // depLine.style.display = 'none'
            }
            dep.style.zIndex = 1001
            el.style.display = 'block'
        }

        console.log('d :>> ', d);

        this.setState({ objDeptSelectat: d })


    }
    changeAngajatNume = (s, ev, d) => {

        if (this.props.scop === 'Organigrama') {

            // console.log('d :', d);

            let cloneDepartamente = [...this.state.listOrganigrama]

            let idxD = cloneDepartamente.findIndex(de => de.id === d.id)

            let idxA = cloneDepartamente[idxD].angajati.findIndex(a => a.id === s.id)

            // console.log('cloneDeparta :', cloneDepartamente[idxD].angajati[idxA]);

            cloneDepartamente[idxD].angajati[idxA].nume = ev.target.value

            this.setState({ listOrganigrama: cloneDepartamente })

        }

    }

    updateAngajat = async (s, d) => {
        if (this.props.scop === 'Organigrama') {
            let cloneDepartamente = [...this.state.listOrganigrama]

            let idxD = cloneDepartamente.findIndex(de => de.id === d.id)

            let idxA = cloneDepartamente[idxD].angajati.findIndex(a => a.id === s.id)

            // console.log('cloneDeparta :', cloneDepartamente[idxD].angajati[idxA]);

            let ws = new Ws();

            let updateAngajat = ws.update('angajati', { nume: cloneDepartamente[idxD].angajati[idxA].nume }, { id: cloneDepartamente[idxD].angajati[idxA].id })

            let updateUser = ws.update('useri', { nume: cloneDepartamente[idxD].angajati[idxA].nume }, { id: cloneDepartamente[idxD].angajati[idxA].id_user })

            let [uA, uU] = await Promise.all([updateAngajat, updateUser])
            if (uA.Succes && uU.Succes) {
                this.getOrganigrama()
            }
        }

    }


    insertAngajat = async (d) => {
        if (this.props.scop === 'Organigrama') {
            // console.log('d :', d);
            // console.log('this.state.anga :', this.state.angajatNou);

            let fs = new FromServer()


            let objToInsert = {
                nume: this.state.angajatNou,
                email: '',
                telefon: ''
            }

            let insertUser = await fs.insertUser(objToInsert)


            let ws = new Ws();

            if (insertUser.ok) {

                // console.log('insertUser :', insertUser);
                let iAngajat = await ws.insert('angajati', { nume: this.state.angajatNou, id_categorie: 1, id_user: insertUser.content[0].id })



                if (iAngajat.Succes) {
                    let iDep = await ws.insert('angajati_departamente', {
                        id_angajat: iAngajat.Content[0].id,
                        id_departament: d.id
                    })

                    if (iDep.Succes) {
                        this.setState({ angajatNou: 'Adauga Angajat' }, () => {

                            this.getOrganigrama()
                        })
                    }
                }

            }

        }
    }

    deleteAngajat = async (a, d) => {
        if (this.props.scop === 'Organigrama') {
            // console.log('a :', a);
            let ws = new Ws()


            let deleteUser = await ws.update('useri', { inactiv: 1 }, { id: a.id_user })

            let deleteAngajat = await ws.update('angajati_departamente', {
                inactiv: 1
            },
                {
                    id_angajat: a.id,
                    id_departament: d.id
                })

            if (deleteAngajat.Succes) {
                this.getOrganigrama()
            }
        }
    }

    esteSef = async (a, ev, d) => {

        if (this.props.scop === 'Organigrama') {

            // console.log('a---------------- :', a);
            let ws = new Ws()

            let event = ev.target.checked

            let deleteAngajat = await ws.update('angajati_departamente', { sef_departament: event === true ? 1 : 0 },
                { id_angajat: a.id })

            if (deleteAngajat.Succes) {

                let angajat = { ...a }

                angajat.sef_departament = event === true ? 1 : 0
                this.setState({


                    objInfoAngajat: angajat
                }, () => {
                    this.getOrganigrama(angajat)
                })
            }

        } else if (this.props.scop === 'Chestionare') {

            let departamente = [...this.state.listOrganigrama]

            let idxD = departamente.findIndex(dep => dep.id === d.id)

            let angajati = departamente[idxD].angajati

            let idxA = angajati.findIndex(an => an.id === a.id)

            angajati[idxA].selectat = ev.target.checked

            angajati[idxA].sef_departament = ev.target.checked

            // console.log('ev.target.checked :', ev.target.checked);

            // console.log('angajati[idxA]----------------- :', angajati[idxA]);

            this.setState({
                listOrganigrama: departamente,
                objInfoAngajat: angajati[idxA]
            }, () => {


                this.props.angajatSelectat(a, angajati[idxA].selectat)
            })


        }

    }

    colorChange = async (ev, d) => {
        if (this.props.scop === 'Organigrama') {
            let departamente = [...this.state.listOrganigrama]

            let idx = departamente.findIndex(dep => dep.id === d.id)

            departamente[idx].color = ev.target.value

            let ws = new Ws();

            let updateColor = await ws.update('organigrama_display_data', { color: ev.target.value },
                { id_departament: departamente[idx].id })

            if (updateColor.Succes) {
                this.setState({ listOrganigrama: departamente }, () => {
                    // console.log('this.state.departamente :', this.state.departamente);
                })
            }
        }
    }

    checkedAngajat = (s) => {



        if (this.props.scop === 'Organigrama') {
            return (s.sef_departament !== 1 ? false : true)
        } else if (this.props.scop === 'Chestionare') {
            return s.selectat
        }
    }

    selectDepartament = (ev, d) => {

        let departamente = [...this.state.listOrganigrama]

        let idxD = departamente.findIndex(dep => dep.id === d.id)

        let angajati = departamente[idxD].angajati

        let counter = angajati.length

        for (let i = 0; i < counter; i++) {
            angajati[i].selectat = ev.target.checked
        }

        departamente[idxD].selectat = ev.target.checked
        this.setState({
            listOrganigrama: departamente,
            objDeptSelectat: departamente[idxD]
        }, () => {
            this.props.selectDepartament(d, departamente[idxD].selectat, departamente[idxD].angajati)
        })



    }

    openDelete = (d) => {
        this.setState({
            isOpenDelete: true,
            objDeptSelectat: d
        })
    }

    deleteDepartament = async () => {
        if (this.props.scop === 'Organigrama') {
            let ws = new Ws();

            // console.log('this.state.objDeptSelectat :', this.state.objDeptSelectat);

            let deleteDep = await ws.update('departamente', { inactiv: 1 }, { id: this.state.objDeptSelectat.id })

            if (deleteDep.Succes) {
                this.setState({ isOpenDelete: false }, () => {

                    this.getOrganigrama()
                })
            }
        }

    }

    selectFile = (id) => {
        if (this.props.scop === 'Organigrama') {
            //  console.log('Incepe poza');
            let pi = document.getElementById(id);

            pi.click()
        }
    }

    uploadPoza = async (id, idAngajat, bkId) => {

        if (this.props.scop === 'Organigrama') {
            let ws = new Ws();
            //  console.log('Picture changed func');
            let saveFile = document.getElementById(id).files[0];
            let reader = new FileReader();
            reader.readAsDataURL(saveFile);

            let chPoza = document.getElementById(bkId)




            reader.onload = async () => {
                let fileContent = reader.result;
                chPoza.style.backgroundImage = ` url(${fileContent})`
                // console.log(fileContent);
                // console.log('saveFile :', saveFile);


                let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

                // console.log('uploadImage :', uploadImage);
                if (uploadImage.Succes) {


                    this.getOrganigrama(this.state.objInfoAngajat)

                }
                //console.log('uploadimage :', uploadImage);
                // console.log('uploadFileApiCall :', uploadFileApiCall);

            }
        }
    }

    uploadDepartamentImage = async (id, idDepartament) => {

        if (this.props.scop === 'Organigrama') {
            let ws = new Ws();
            //  console.log('Picture changed func');
            let saveFile = document.getElementById(id).files[0];
            let reader = new FileReader();
            reader.readAsDataURL(saveFile);

            reader.onload = async () => {
                let fileContent = reader.result;
                // console.log(fileContent);
                // console.log('saveFile :', saveFile);


                let uploadImage = await ws.uploadimage('Upload/AvatarDepartament', saveFile, idDepartament);

                // console.log('uploadImage :', uploadImage);
                if (uploadImage.Succes) {


                    this.getOrganigrama()

                }
                //console.log('uploadimage :', uploadImage);
                // console.log('uploadFileApiCall :', uploadFileApiCall);

            }
        }
    }

    dragStartAngajat = (a, id, d) => {

        if (this.props.scop === 'Organigrama') {
            // console.log('angajat :', a);

            let el = document.getElementById(id)

            el.classList.add('dragging')

            this.setState({
                angajatSelectat: a

            })
        }
    }

    dragEndAngajat = (id) => {
        if (this.props.scop === 'Organigrama') {
            let el = document.getElementById(id)

            el.classList.remove('dragging')
        }
    }

    dragAngajatOver = (ev) => {
        if (this.props.scop === 'Organigrama') {
            ev.preventDefault();
        }
    }

    dropAngajat = async (d) => {
        if (this.props.scop === 'Organigrama') {
            let ws = new Ws();

            let selectCountAngajati = await ws.customSelect('select count(*) as count from angajati_departamente where id_departament = @p1 and id_angajat = @p2 and isnull(inactiv,0) != 1', {
                p1: d.id,
                p2: this.state.angajatSelectat.id
            })

            if (selectCountAngajati.Succes) {
                // console.log('selectCountAngajati :', selectCountAngajati);
                // console.log('this.state.angajatSelectat :', this.state.angajatSelectat);
                if (selectCountAngajati.Content[0].count === 0) {
                    let insertAngajat = await ws.insert('angajati_departamente', {
                        id_angajat: this.state.angajatSelectat.id,
                        id_departament: d.id,
                        sef_departament: this.state.angajatSelectat.sef_departament
                    })
                    if (insertAngajat.Succes) {
                        this.getOrganigrama()
                    }
                }
            }
        }

    }

    openDetaliiAngajat = (a, d) => {

        if (this.props.scop === 'Organigrama') {
            this.setState({
                isOpenDetaliiAngajat: true,
                objDeptSelectat: d,
                objInfoAngajat: a
            })

        }



    }

    updateAngajatDetails = async (a) => {
        //    console.log('a :', a);

        let angajat = a
        if (this.props.scop === 'Organigrama') {

            let ws = new Ws();

            // console.log('a :', angajat);
            let objToUpdate = {

                adresa: angajat.adresa || '',
                email: angajat.email || '',
                telefon: angajat.telefon || '',
                nume: angajat.nume || '',
                oras: angajat.oras || '',
                cost_minut: angajat.cost_minut || 0,
                tip_moneda: angajat.tip_moneda || 'lei',
                salariu_brut: angajat.salariu_brut || '',
                functie: angajat.functie || '',
                cnp: angajat.cnp || ''

            }

            let updateAngajat;

            if (angajat.id_user) {

                updateAngajat = ws.update('angajati', objToUpdate, { id: angajat.id })
                let updateUser = ws.update('useri', { email: angajat.email || '', telefon: angajat.telefon || '', nume: angajat.nume || '' }, { id: angajat.id_user })


                let [u, a] = await Promise.all([updateUser, updateAngajat])
                // console.log('updateAngajat :', updateAngajat);
                if (u.Succes && a.Succes) {

                    this.setState({ isOpenDetaliiAngajat: false }, () => {
                        this.getOrganigrama()
                    })
                }
            } else {
                updateAngajat = await ws.update('angajati', objToUpdate, { id: angajat.id })

                // console.log('updateAngajat :', updateAngajat);
                if (updateAngajat.Succes) {
                    this.setState({ isOpenDetaliiAngajat: false }, () => {
                        this.getOrganigrama()
                    })
                }
            }



        }
    }

    handleAngajat = nume => ev => {
        let cloneAngajat = { ...this.state.objInfoAngajat }

        cloneAngajat[nume] = ev.target.value

        this.setState({ objInfoAngajat: cloneAngajat })
    }

    changeProgram = nume => ev => {
        let oldState = { ...this.state.angajatInfo }

        oldState[nume] = ev.target.value

        this.setState({
            angajatInfo: oldState
        })
    }

    absent = (ev, zi) => {
        //    console.log('ev :', ev);

        //    console.log('zi :', zi);

        let oldState = { ...this.state.angajatInfo }

        if (oldState[zi] === '00:00') {
            oldState[zi] = '09:00'
        } else {
            oldState[zi] = '00:00'
        }
        this.setState({
            angajatInfo: oldState
        })
    }

    saveProgram = async () => {

        let ws = new Ws();

        console.log('this.state.angajatInfo :>> ', this.state.angajatInfo);

        let verifyProgram = await ws.customSelect('select count(*) as c from program_lucru where id_angajat = @p1', {
            p1: this.state.angajatInfo.id
        })

        let objToInsert = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,
            id_angajat: this.state.angajatInfo.id

        }

        let objToUpdate = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,

        }

        // console.log('objToInsert :', objToInsert);


        // console.log('verifyProgram :', verifyProgram);
        if (verifyProgram.Succes) {
            if (verifyProgram.Content[0].c === 0) {
                let insertProgram = await ws.insert('program_lucru', objToInsert)

                if (insertProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            } else {
                let updateProgram = await ws.update('program_lucru', objToUpdate, { id_angajat: this.state.objInfoAngajat.id })

                if (updateProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            }
        }
    }


    openNewUser = async (d) => {



        let ls = new LocalStorage().GetUserData()

        if (ls.InfoUser.NrMaxUtilizatori > this.state.listUseriAll.length) {
            let ws = new Ws();


            let objToInsert = {
                nume: 'Nume Angajat',
                email: '',
                telefon: ''
            }

            let insertUser = await ws.insert('useri', objToInsert)




            if (insertUser.Succes) {

                // console.log('insertUser :', insertUser);
                let iAngajat = await ws.insert('angajati', { nume: objToInsert.nume, id_categorie: 1, data_angajarii: this.u.updateSqlNow(), id_user: insertUser.Content[0].id })





                if (iAngajat.Succes) {
                    // let iDep =await ws.insert('angajati_departamente',{id_angajat:iAngajat.Content[0].id,
                    //                                             id_departament:d.id})



                    let angajatInfo = {
                        adresa: "",
                        cnp: "",
                        cost_minut: '',
                        email: "",
                        firma: '',
                        firma_externa: 0,
                        functie: "",
                        id: iAngajat.Content[0].id,
                        id_departament: d.id,
                        id_user: insertUser.Content[0].id,
                        nume: "",
                        nume_departament: "",
                        oras: "",
                        poza: "",
                        salariu: '',
                        sef_departament: '',
                        telefon: "",
                        access_financiar: '',
                        nr_zile_concediu: '',
                        salariu_moneda: 'lei',
                        permis_conducere: ''
                    }
                    this.setState({
                        angajatInfo: angajatInfo,
                        toUpdate: false,
                        isOpenNewUser: true,
                        isFirmaExterna: false,
                        dAccess: []
                    })
                }

            }

        } else {
            this.setState({ openAlertUseri: true })
        }



    }


    closeNewUser = async () => {
        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: this.state.angajatInfo.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: this.state.angajatInfo.id, id_departament: this.state.angajatInfo.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: this.state.angajatInfo.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: this.state.angajatInfo.id_user })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({
                isOpenNewUser: false,
                vParola: '',
                verifyEmail: ''
            })
        }

    }

    changeFirma = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        if (ev.target.checked) {
            angajat.departament = ''
            this.setState({
                angajatInfo: angajat,
                isFirmaExterna: ev.target.checked
            })
        } else {
            angajat.firma = ''
            this.setState({
                angajatInfo: angajat,
                isFirmaExterna: ev.target.checked
            })
        }
    }

    changeData = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        console.log('angajat :>> ', angajat);

        angajat[ev.target.name] = ev.target.value

        this.setState({
            angajatInfo: angajat,
            verifyEmail: ''
        })
    }

    insertNewUser = async () => {
        let ws = new Ws();
        let u = new Utils();



        let _verifyEmail = ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri = ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati = ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id
        })

        console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri, verifyEmailAngajati] = await Promise.all([_verifyEmail, _verifyEmailUseri, _verifyEmailAngajati])



        console.log('verifyEmail :>> ', verifyEmail);

        if (verifyEmail.Succes) {
            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0 && this.state.parola.length >= 5) {


                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    data_angajarii: u.updateSqlNow(),
                    salariu_moneda: this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu: this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere: this.state.angajatInfo.permis_conducere || '',


                }

                let objUser = {
                    token: u.randomData(32),
                    nume: this.state.angajatInfo.nume,
                    email: this.state.angajatInfo.email,
                    access_financiar: this.state.angajatInfo.access_financiar || ''
                }


                objUser['firma'] = this.state.angajatInfo.firma
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0

                let getSocietate = await ws.customSelect('select * from setari where param_code = @p1', {
                    p1: 'soc_id'
                })

                if (getSocietate.Succes) {

                    let objNewUserLogator = {
                        token: objUser.token,
                        nume: this.state.angajatInfo.nume,
                        id_societate_client: getSocietate.Content[0].val,
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        id_user_bazadate_proprie: this.state.angajatInfo.id_user,
                    }

                    let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                    let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                    let iUserDrepturi = ws.insert('useri_drepturi', {
                        id_utilizator: this.state.angajatInfo.id_user,

                        profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                        acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        sterge_proiecte: 0

                    })

                    let insertD = ws.insert('angajati_departamente', {
                        id_angajat: this.state.angajatInfo.id,
                        id_departament: this.state.angajatInfo.id_departament,
                        sef_departament: this.state.angajatInfo.sef_departament || ''
                    })
                    let insertNewUser = ws.insert('pm_logator.[dbo].useri', objNewUserLogator)


                    let [a, u, d, n, iU] = await Promise.all([updateA, updateU, insertD, insertNewUser, iUserDrepturi])

                    console.log('iU :>> ', iU);

                    if (a.Succes && u.Succes && d.Succes && n.Succes) {



                        this.setState({ isOpenNewUser: false, parola: '', repetParola: '', vParola: '', verifyEmail: '' }, () => {

                            this.getOrganigrama()
                        })
                    }


                    // console.log('insertNewUser :', insertNewUser);

                }






            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }

        }
    }

    updateAngajat = async () => {

        let ws = new Ws();
        let u = new Utils();

        // let verifyEmail = await ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
        //     p1: this.state.angajatInfo.email,
        //     p2: this.state.angajatInfo.id_user
        // })

        // console.log('verifyEmail :>> ', verifyEmail);

        // console.log('angajatInfo :>> ', this.state.angajatInfo);




        let _verifyEmail = ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 and isnull(inactiv,0) != 1 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailUseri = ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        let _verifyEmailAngajati = ws.customSelect('select * from angajati where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id
        })

        console.log('verifyEmail :>> ', verifyEmail);

        let [verifyEmail, verifyEmailUseri, verifyEmailAngajati] = await Promise.all([_verifyEmail, _verifyEmailUseri, _verifyEmailAngajati])




        console.log('getUserLogator :>> ', verifyEmail);
        if (verifyEmail.Succes) {

            if (verifyEmail.Content.length === 0 && verifyEmailUseri.Content.length === 0 && verifyEmailAngajati.Content.length === 0) {

                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                    salariu_moneda: this.state.angajatInfo.salariu_moneda || '',
                    nr_zile_concediu: this.state.angajatInfo.nr_zile_concediu || '',
                    permis_conducere: this.state.angajatInfo.permis_conducere || '',



                }

                let objUser = {
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    access_financiar: this.state.angajatInfo.access_financiar || ''

                }

                let objNewUserLogator;

                if (this.state.parola.length > 3) {

                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,

                    }
                } else {
                    objNewUserLogator = {
                        email: this.state.angajatInfo.email,
                        // parola: this.state.parola,
                        // parolac: this.state.parola,

                    }
                }


                console.log('objNewUserLogator :>> ', objNewUserLogator);



                objUser['firma'] = this.state.angajatInfo.firma
                objUser['firma_externa'] = this.state.isFirmaExterna ? 1 : 0



                let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })





                let selectDrepturi = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
                    p1: this.state.angajatInfo.id_user
                })

                let iUserDrepturi

                if (selectDrepturi.Succes) {
                    if (selectDrepturi.Content.length > 0) {
                        console.log('are Drepturi  :>> ', selectDrepturi.Content);

                        iUserDrepturi = ws.update('useri_drepturi', {

                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        }, { id_utilizator: this.state.angajatInfo.id_user, })
                    } else {
                        iUserDrepturi = ws.insert('useri_drepturi', {
                            id_utilizator: this.state.angajatInfo.id_user,
                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',


                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        })
                    }
                }





                // let iUserDrepturi = ws.insert('useri_drepturi', {

                //     id_utilizator:this.state.angajatInfo.id_user,

                //     profil_selectat:'Admin',

                //     acces_rapoarte: 1 ,
                //     acces_setari:  1 ,
                //     acces_utilizatori :  1 ,

                //     acces_extins_proiecte :  1 ,

                //     acces_evaluari :  1 ,
                //     can_edit_evaluari :  1 ,

                //     acces_monitorizare :  1 ,
                //     can_edit_monitorizare :  1 ,

                //     sterge_proiecte: 1

                // })




                let updateD = ws.update('angajati_departamente', {
                    id_departament: this.state.angajatInfo.id_departament || '',
                    sef_departament: this.state.angajatInfo.sef_departament || ''
                }, { id_angajat: this.state.angajatInfo.id })

                let updateNewUserL = ws.update('pm_logator.[dbo].useri', objNewUserLogator, { id_user_bazadate_proprie: this.state.angajatInfo.id_user, id_societate_client: Number(this.state.societate.val) })

                let [uA, uU, uD, iU, uL] = await Promise.all([updateA, updateU, updateD, iUserDrepturi, updateNewUserL])

                console.log('uA :>> ', uA);
                console.log('uU :>> ', uU);
                console.log('uD :>> ', uD);
                console.log('iU :>> ', iU);
                console.log('uL :>> ', uL);

                if (uA.Succes && uU.Succes && uD.Succes) {
                    this.setState({
                        isOpenNewUser: false,
                        parola: '',
                        repetParola: '',
                        verifyEmail: '',
                        vParola: ''
                    }, () => {
                        this.getOrganigrama()
                    })
                }
            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }


        }
    }

    changeManager = (ev) => {


        let manager = { ...this.state.angajatInfo }

        console.log('manager :>> ', manager);

        manager["sef_departament"] = ev.target.checked ? 1 : 0

        this.setState({ angajatInfo: manager })
    }

    changeAccessFinanciar = (ev) => {
        let accessFinanciar = { ...this.state.angajatInfo }

        accessFinanciar['access_financiar'] = ev.target.checked ? 1 : 0

        this.setState({ angajatInfo: accessFinanciar })
    }

    deleteUser = async (us) => {

        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1, statusul: 'Candidat' }, { id: us.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: us.id, id_departament: us.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: us.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { token: us.token })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({
                isOpenNewUser: false,
                openDeleteUser: false
            }, () => {

                this.getOrganigrama()
            })
        }

    }


    openDeleteUser = (u) => {

        this.setState({
            angajatInfo: u,
            openDeleteUser: true
        })
    }


    selectUserIntern = async (u) => {

        console.log('u :>> ', u);

        let ws = new Ws()

        let user = { ...u }

        let _departementeAcces = await ws.customSelect(`select d.*, a.id as id_departament_access, a.id_angajat from angajati_acces_departamente a left join departamente d  on
        d.id = a.id_departament where a.id_angajat = @p1 and isnull(a.sters,0) != 1`, { p1: u.id })

        if (_departementeAcces.Succes) {
            // user.sef_departament = user.sef_departament === 1


            this.setState({
                angajatInfo: user,
                isOpenNewUser: true,
                toUpdate: true,
                isFirmaExterna: u.firma_externa === 1 ? true : false,
                dAccess: _departementeAcces.Content
            })
        }

    }


    changeidDepartament = async (ev) => {


        let ws = new Ws()

        let val = ev.target.value

        let depAccess = [...this.state.dAccess]

        let idx = depAccess.findIndex(d => Number(d.id) === Number(val))

        if (idx === -1) {
            let insertDepAccess = await ws.insert('angajati_acces_departamente', {
                id_angajat: this.state.angajatInfo.id,
                id_departament: val
            })

            if (insertDepAccess.Succes) {
                this.getOrganigrama()
            }
        }
    }


    deleteDep = async (d) => {

        let ws = new Ws()
        console.log('d :>> ', d);

        let delDep = await ws.update('angajati_acces_departamente', { sters: 1 }, { id: d.id_departament_access })

        if (delDep.Succes) {
            this.getOrganigrama()
        }



    }

    newDeptNew = async () => {

        let ws = new Ws();
        let ls = new LocalStorage().GetUserData()



        let dep = this.state.objDeptSelectat

        console.log('dep :>> ', dep);



        let objInsertDep = {

            nume: 'Departament Nou',
            id_parent: dep.id ? dep.id : 1,
            level: dep.level ? dep.level + 1 : 2

        }

        console.log('objInsertDep :>> ', objInsertDep);

        let insertDep = await ws.insert('departamente', objInsertDep)

        if (insertDep.Succes) {
            let objToInsertDisplay = {
                margintop: dep.margintop ? dep.margintop + 150 : 150,
                marginleft: dep.marginleft ? dep.marginleft : 500,
                id_departament: insertDep.Content[0].id
            }

            console.log('objToInsertDisplay :>> ', objToInsertDisplay);

            let insertDisplay = await ws.insert('organigrama_display_data', objToInsertDisplay)

            if (insertDisplay.Succes) {

                this.getOrganigrama()
            }
        }

    }


    render() {
        return (
            <div id='pm-organigrama-container'
                style={{
                    position: 'relative',
                    width: '100%',
                    minHeight: '100vh',
                    overflow: 'auto',
                    height: '100%'
                }}>

                {this.state.openProgramCompanie &&

                    <ProgramCompanie
                        open={this.state.openProgramCompanie}
                        dialogClose={() => { this.setState({ openProgramCompanie: false }) }}
                    />
                }

                <AlertNew
                    open={this.state.openDeleteUser}
                    dialogClose={() => { this.setState({ openDeleteUser: false }) }}
                    title={this.dictionary.managementUtilizatori.stergeUtilizator}
                    mesaj={this.dictionary.managementUtilizatori.utilizatoriiNuPotFiRecuperati}
                    yesFunction={() => { this.deleteUser(this.state.angajatInfo) }}
                    deleteP={true}
                />

                <AlertNew
                    open={this.state.openAlertUseri}
                    dialogClose={() => { this.setState({ openAlertUseri: false }) }}
                    title={'Numarul maxim de utilizatori a fost atins !'}
                    mesaj={''}
                    noButtonDisplay={1}
                    yesFunction={() => { this.setState({ openAlertUseri: false }) }}
                />

                <AlertDialog
                    limba={this.dictionary}
                    open={this.state.isOpenDelete}
                    dialogClose={() => { this.setState({ isOpenDelete: false }) }}
                    title={this.dictionary.managementUtilizatori.stergeDepartament}
                    yesFunction={this.deleteDepartament} />

                <div
                    // onMouseDown={this.newElDrag} 
                    onClick={this.newDeptNew}
                    id={`newdep`} style={{
                        padding: 20,
                        display: this.props.scop === 'Organigrama' ? 'block' : 'none',
                        position: 'fixed',
                        cursor: 'crosshair',
                        right: 50,
                        zIndex: 999,
                        borderRadius: 4,
                        top: 80,

                        color: 'white',
                        backgroundColor: 'rgb(24, 166, 59)'
                    }}>



                    + {this.dictionary.managementUtilizatori.adaugaDepartament}


                </div>


                <ProgramLucru
                    open={this.state.isOpenProgram}
                    dialogClose={() => { this.setState({ isOpenProgram: false }) }}
                    limba={this.dictionary}
                    angajat={this.state.angajatInfo}
                    changeProgram={this.changeProgram}
                    absent={this.absent}
                    salveazaProgram={this.saveProgram}
                    programSelectat={this.state.programSelectat}
                    changeProgramAll={this.changeProgramAll}
                    programCompanie={this.state.programCompanie}
                />

                <UpdateAngajatDetails
                    open={this.state.isOpenDetaliiAngajat}
                    dialogClose={() => { this.setState({ isOpenDetaliiAngajat: false }) }}
                    angajat={this.state.objInfoAngajat}
                    selectFile={this.selectFile}
                    limba={this.dictionary}
                    openProgram={() => { this.setState({ isOpenProgram: true }) }}
                    changeNume={this.handleAngajat('nume')}
                    changeTelefon={this.handleAngajat('telefon')}
                    changeAdresa={this.handleAngajat('adresa')}
                    changeOras={this.handleAngajat('oras')}
                    changeEmail={this.handleAngajat('email')}
                    changeCost={this.handleAngajat('cost_minut')}
                    changeMoneda={this.handleAngajat('tip_moneda')}
                    changeFunctia={this.handleAngajat('functie')}
                    changeSalariu={this.handleAngajat('salariu_brut')}
                    changeCnp={this.handleAngajat('cnp')}
                    updateAngajat={this.updateAngajatDetails}
                    departament={this.state.objDeptSelectat}
                    esteSef={this.esteSef}
                    checkedSef={this.checkedAngajat}
                    getOrganigrama={this.getOrganigrama}
                    tipuriMoneda={this.state.tipuriMoneda}
                />



                {/* {this.showGridLines()} */}

                <div id='vertical-line' style={{
                    width: 1,
                    height: '100vh',
                    position: 'absolute',
                    display: 'none',
                    left: 100,
                    borderLeft: '1px dotted blue'
                }}></div>
                <div id='horizontal-line' style={{
                    height: 1,
                    width: '100vw',
                    top: 100,
                    position: 'absolute',
                    display: 'none',
                    borderTop: '1px dotted blue'
                }}></div>

                {this.state.listOrganigrama.map((d, idx) => {
                    return (
                        <div className='pm-organigrama-item' id={`dep${idx}`}
                            // onMouseUp={(ev) => { this.mouseOverDep(ev, d) }} onMouseDown={(ev) => { this.dragEl(ev, d, `dep${idx}`, `etapaline${idx}`) }} 

                            style={{
                                padding: d.padding,
                                display: 'block',
                                position: 'absolute',
                                cursor: 'crosshair',
                                left: d.marginleft,
                                top: d.margintop,
                                borderRadius: 25,
                                zIndex: 1000,
                                color: 'black',
                                backgroundColor: 'white'
                            }} key={`dept${idx}`}>

                            {/* {d.ipo !== null &&  */}
                            <div id={`etapaline${idx}`} className='pm-task-etapa-line' style={{

                                height: d.cat2,
                                width: 2,
                                backgroundColor: 'black',
                                zIndex: 1000,
                                bottom: this.localConfig.height,
                                transform: `skew(${d.degree}deg)`

                            }}>
                            </div>



                            {/* } */}





                            {/* <div className='pm-departament-picture' 
                                                style={{backgroundImage:`url('${d.poza ? (new Ws().adresaMedia + '/Departamente/' + d.poza): departament}')`}}
                                                onClick={()=>{this.selectFile(`fileDep${d.id}`)}}
                                                >
                                                 
                                           </div> */}







                            {/* 
                                           <input type='file' id={`fileDep${d.id}`}
                                                              style={{display:'none'}}
                                                              accept='image/*'
                                                              onChange={()=>{this.uploadDepartamentImage(`fileDep${d.id}`, d.id)}} />                    */}
                            {
                                this.props.scop === 'Chestionare' &&
                                <Checkbox style={{ color: '#000000', padding: 0 }}
                                    onChange={(ev) => { this.selectDepartament(ev, d) }}
                                    checked={d.selectat} />

                            }

                            <i style={{ display: 'block', width: 'fit-content' }} onMouseDown={(ev) => { this.dragElButton(ev, d, `dep${idx}`, `etapaline${idx}`) }} className='material-icons'>drag_indicator</i>




                            <Grid
                                // onMouseUp={(ev) => { this.mouseOverDep(ev, d) }} onMouseDown={(ev) => { this.dragEl(ev, d, `dep${idx}`, `etapaline${idx}`) }} id={`dep${idx}`} 
                                style={{ padding: '40px 20px 40px 20px', position: 'relative' }} container>

                                {this.state.objDeptSelectat.id === d.id &&
                                    <i onClick={() => { this.getAngajati(d, idx) }} style={{ position: 'absolute', top: 10, left: 0, right: 0, margin: 'auto' }} className='material-icons'>keyboard_arrow_up</i>

                                }



                                <Grid style={{ textAlign: 'left' }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <span style={{ display: 'block', textAlign: 'left', paddingLeft: 2, fontSize: 16, fontWeight: 500 }} className='textSecondary'> {this.dictionary.managementUtilizatori.departament}</span>
                                    <input id={`inp${idx}`}
                                        onClick={this.inputClicked}
                                        className='pm-departament-input'
                                        type='text'
                                        disabled={this.props.scop === 'Organigrama' ? false : true}
                                        maxLength={36}
                                        value={d.nume}
                                        onChange={(ev) => { this.changeNume(ev, d) }}
                                        onBlur={() => { this.updateNumeDep(d) }} />
                                </Grid>
                                <Grid style={{ textAlign: 'right', paddingTop: 14 }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                    <i id={`angU${idx}`} onClick={() => { this.getAngajati(d, idx) }} className='material-icons' style={{

                                        cursor: 'pointer',

                                    }}>people</i>

                                    {/* <UserSolid id={`angU${idx}`} onClick={() => { this.getAngajati(d, idx) }} className=' iconSvg' /> */}

                                    {
                                        this.props.scop === 'Organigrama' && d.id_parent !== null &&

                                        <i className='material-icons' style={{
                                            marginLeft: 20
                                        }}
                                            onClick={() => { this.openDelete(d) }}
                                        >delete</i>

                                        // <TrashAlt onClick={() => { this.openDelete(d) }} style={{ marginLeft: 20 }} className=' iconSvg' />



                                    }

                                </Grid>

                            </Grid>

                            {/* <input id={`inp${idx}`} 
                                    onClick={this.inputClicked}   
                            
                                    type='text' 
                         
                                    value={d.nume} 
                                    onChange={(ev)=>{this.changeNume(ev,d)}} 
                                    onBlur = {()=>{this.updateNumeDep(d)}} /> */}

                            {/* <i onClick={()=>{this.getAngajati(d,idx)}} className='material-icons' style={{position:'absolute', 
                                                                            bottom:0,
                                                                            cursor:'pointer', 
                                                                            right:10, 
                                                                            zIndex:5000}}>people</i> */}

                            {/* <i className='material-icons' style={{position:'absolute', 
                                                                            top:0, left:10, 
                                                                            zIndex:5000, 
                                                                            cursor:'pointer'}}>code</i>         */}

                            {/* {
                                                    this.props.scop === 'Organigrama' && d.id_parent !== null &&
                                                    <i className='material-icons' style={{position:'absolute', 
                                                    bottom:0, left:10, 
                                                    zIndex:5000, 
                                                    cursor:'pointer'}}
                                                    onClick={()=>{this.openDelete(d)}}
                                                    >delete</i>  

                                                   
                                                }   */}


                            <Grid onDrop={() => { this.dropAngajat(d) }}
                                onDragOver={(ev) => { this.dragAngajatOver(ev) }} style={{
                                    display: 'none',
                                    transition: '1s',
                                    minWidth: 350,
                                    maxHeight: 300,
                                    marginBottom: 10,
                                    overflow: 'scroll'
                                }} id={`ang${idx}`} container className='pm-insert-task-header'>

                                {/* {
                                                this.props.scop === 'Organigrama' &&
                                                <Grid  style={{marginBottom:20}} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                            
                                                <FormControl className='pm-color-task-select' style={{backgroundColor:d.color || '#ef1313f0', 
                                                                            width:'80%',
                                                                        
                                                                                                    }} variant="filled" >
                                                        <InputLabel  style={{color:'white'}} htmlFor="filled-color-simple">
                                                        Culoare Departament
                                                        </InputLabel>
                                                        <Select
                                                    
                                                        value={d.color || ''}
                                                        onChange={(ev)=>{this.colorChange(ev,d)}}
                                                        input={
                                                            <FilledInput  name="color" id="filled-color-simple" />
                                                        }  
                                                    
                                                        >
                                                        {this.state.culoriDepartamente.map((c,idx)=>{
                                                            return(
                                                                <MenuItem style={{backgroundColor:c}} key={idx} value={c}></MenuItem>
                                                            )
                                                        })}
                                                        </Select>
                                                    </FormControl>
    
                                                
    
                                                </Grid>

                                            } */}

                                {d.angajati.map((s, idx) => {
                                    return (



                                        <Grid
                                            container
                                            // draggable 

                                            // onDragStart={()=>{this.dragStartAngajat(s,`angContainer${s.id}`)}} 
                                            // onDragEnd={()=>{this.dragEndAngajat(`angContainer${s.id}`)}}
                                            id={`angContainer${s.id}`}
                                            key={idx}
                                            style={{ textAlign: 'left', marginBottom: 10 }}
                                            className='pm-insert-task-item'
                                        //  item xs={12} sm={12} md={12} lg={12} xl={12} 
                                        >


                                            <Grid onClick={() => { this.selectUserIntern(s) }} item xs={10} sm={10} md={10} lg={10} xl={10} >
                                                <i id={`angU${idx}`} className='material-icons' style={{ verticalAlign: 'bottom', marginRight: 20 }}>people</i>
                                                {/* <UserSolid style={{ verticalAlign: 'bottom', marginRight: 20 }} className=' iconSvg' /> */}
                                                <input id={`angInp${s.id}`}
                                                    onClick={this.inputClicked}
                                                    style={{ width: '60%' }}
                                                    className='chestionare-task-description-input'
                                                    type='text'
                                                    disabled={true}
                                                    value={s.nume}
                                                    onChange={(ev) => { this.changeAngajatNume(s, ev, d) }}
                                                    onBlur={() => { this.updateAngajat(s, d) }} />
                                            </Grid>
                                            <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2} >
                                                {this.props.scop === 'Organigrama' && d.id !== 1 &&
                                                    <i onClick={() => { this.openDeleteUser(s) }} className="material-icons pm-delete-subtask">delete</i>
                                                    // <TrashAlt onClick={() => { this.deleteAngajat(s, d) }} style={{ marginLeft: 20 }} className=' iconSvg' />

                                                }
                                            </Grid>




                                            {/* <Checkbox style={{color:'#000000'}}  
                                                                onChange={(ev)=>{this.esteSef(s,ev,d)}} 
                                                                    checked={this.checkedAngajat(s)}  />
                                                        <div
                                                        // onClick={()=>{this.selectFile(`file${s.id}`)}}
                                                        onClick={()=>{this.openDetaliiAngajat(s,d)}}
                                                        className='pm-angajati-picture'
                                                        style={{backgroundImage:`url('${s.poza ? (new Ws().adresaMedia + '/Angajati/' + s.poza): avatar}')`}}>

                                                        </div>
                                                        <input type='file' id={`file${s.id}`}
                                                              style={{display:'none'}}
                                                              accept='image/*'
                                                              onChange={()=>{this.uploadPoza(`file${s.id}`, s.id, 'angajat-upload-poza')}} />    
                                                      
                                                        <input id={`angInp${s.id}`} 
                                                                onClick={this.inputClicked}  
                                                                style={{width:'60%'}} 
                                                                className='pm-task-description-input' 
                                                                type='text' 
                                                                disabled={this.props.scop === 'Organigrama' ? false : true}
                                                                value={s.nume} 
                                                                onChange={(ev)=>{this.changeAngajatNume(s,ev,d)}}
                                                                onBlur={()=>{this.updateAngajat(s,d)}}  /> */}



                                            {/* {
                                                       this.props.scop ==='Organigrama' &&

                                                     <i onClick={()=>{this.deleteAngajat(s,d)}} className="material-icons pm-delete-subtask">delete</i>
                                                   } */}


                                        </Grid>

                                    )
                                })}

                                {/* {this.props.scop === 'Organigrama' &&
                                            <Grid 
                                            
                                            style={{textAlign:'left'}} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                            <Checkbox style={{color:'#000000'}}  />
                                            <input
                                                id={`angInpinsert${d.id}`} 
                                                onClick={this.inputClicked} 
                                            style={{width:'70%'}} 
                                                onFocus={()=>{this.setState({angajatNou:''})}} 
                                                className='pm-task-description-input' 
                                                type='text' 
                                                value={this.state.angajatNou} 
                                                onChange={(ev)=>{this.setState({angajatNou:ev.target.value})}}
                                                onBlur={()=>{this.insertAngajat(d)}} 
                                                />
                                        </Grid>
                                } */}

                                {d.id !== 1 &&
                                    <Grid

                                        style={{ textAlign: 'center' }} className='chestionare-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Button style={{ width: '90%', marginBottom: 20, padding: 10 }} variant="contained" onClick={() => { this.openNewUser(d) }} className={'creeaza-button'}>
                                            {this.dictionary.managementUtilizatori.membruNou}
                                        </Button>
                                        {/* <input
                                id={`angInpinsert${d.id}`}
                                onClick={this.inputClicked}
                                style={{ width: '70%' }}
                                onFocus={() => { this.setState({ angajatNou: '' }) }}
                                className='chestionare-task-description-input'
                                type='text'
                                value={this.state.angajatNou}
                                onChange={(ev) => { this.setState({ angajatNou: ev.target.value }) }}
                                onBlur={() => { this.insertAngajat(d) }}
                                /> */}
                                    </Grid>

                                }


                            </Grid>


                        </div>
                    )
                })}

                {/* {.map((i,idx)=>{
                  return(
                      <div key={`level${idx}`} style={{position:'absolute', 
                                                        top:i.top + (this.localConfig.marginLeft * idx),
                                                        width:'100%'}}>
                        
                      </div>
                  )
              })} */}

                {/* {this.state.listOrganigrama.map((o,idx)=>{
                            return(
                                <div key={idx}>
                                    {o.depts.map((d,idx)=>{
                                        return(
                                            <div key = {idx} style={{maxWidth:400 ,display:'inline-block'}}>

                                            <div>  <p style={{textAlign:'center', 
                                                            backgroundColor:new Utils().culoriProiecte(d.id), 
                                                            width:'fit-content', 
                                                            margin:'auto',

                                                            color:'white',
                                                            padding:10,
                                                            borderRadius:20}}>{d.nume}</p>
                                                    <p style={{textAlign:'center',
                                                                backgroundColor:new Utils().culoriProiecte(d.id), 
                                                                width:'fit-content', 
                                                                margin:'auto',
                                                                marginTop:5,
                                                                marginBottom:5,
                                                                color:'white',
                                                                padding:5,
                                                                borderRadius:20}}>{d.sef.nume} </p>
                                            </div>
    
                                                <Grid container style={{margin:'auto',justifyContent:'center'}}>
                                            {d.angajati.map((a,idx)=>{
                                                    return(

                                                        <Grid key = {idx} item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                            <p style={{textAlign:'center',
                                                                backgroundColor:new Utils().culoriProiecte(d.id), 
                                                                width:'fit-content', 
                                                                margin:'auto',
                                                                marginLeft:10, 
                                                                color:'white',
                                                                padding:5,
                                                                borderRadius:20}}>{a.nume}</p>
                                                        </Grid>
                                                    )
                                            })}
    
                                                </Grid>
                                            </div>
                                        )
                                       
                                    })}
                                </div>
                            )
              })} */}


                {this.state.isOpenNewUser &&
                    <NewUserDrepturi
                        open={this.state.isOpenNewUser}
                        dialogClose={this.state.toUpdate ? () => { this.setState({ isOpenNewUser: false }) } : this.closeNewUser}
                        angajat={this.state.angajatInfo}
                        departamente={this.state.listDepartamente}
                        isFirmaExterna={this.state.isFirmaExterna}
                        changeFirma={this.changeFirma}
                        changeData={(ev) => { this.changeData(ev) }}
                        limba={this.dictionary}
                        vEmail={this.state.verifyEmail}
                        updateAngajat={this.state.toUpdate ? this.updateAngajat : this.insertNewUser}
                        parola={this.state.parola}
                        repetParola={this.state.repetParola}
                        parolaChange={(ev) => { this.setState({ parola: ev.target.value }) }}
                        repetaParolaChange={(ev) => { this.setState({ repetParola: ev.target.value }) }}
                        vParola={this.state.vParola}
                        toUpdate={this.state.toUpdate}
                        changeManager={this.changeManager}
                        stergeAngajat={() => { this.openDeleteUser(this.state.angajatInfo) }}
                        getData={() => { this.getOrganigrama(this.state.angajatInfo) }}
                        openProgram={() => { this.setState({ isOpenProgram: true }) }}
                        dAccess={this.state.dAccess}
                        idDepartament={this.state.idDepartament}
                        changeidDepartament={this.changeidDepartament}
                        deleteDep={this.deleteDep}
                        changeAccessFinanciar={this.changeAccessFinanciar}
                    />
                }

            </div>
        );
    }
}

//end class



Organigrama.propTypes = {
    scop: PropTypes.string,
    angajatSelectat: PropTypes.func,
    selectDepartament: PropTypes.func,

}